import { useState, useCallback, useEffect } from 'react';

// Hooks
import useFetchIntervalData from '../../../../packages/hooks/useFetchIntervalData';
import useSubscriptionClick from '../../../../packages/hooks/useSubscriptionClick';

// Utils
import { getTeamById } from '../../../../packages/services/basketball/teams';
import { normalizeTeamResponseData } from '../normalizers/normalizeTeamResponseData';

// Types
import { IGeneralSubscriberInfo } from '../../../../packages/constants/subscribeTypes';
import { IBasketballConfig, SDKOptions } from '../../../../packages/types';

interface ITeam {
  id: string;
  title: string;
  logo: string;
  urlTarget: string;
  url: string;
}

interface IUseTeamArgs extends IGeneralSubscriberInfo {
  dataTeam?: IBasketballConfig['dataTeam'];
  dataRefreshTime?: IBasketballConfig['dataRefreshTime'];
  sdkOptions: SDKOptions;
  dataEntityLinks?: IBasketballConfig['dataEntityLinks'];
}

export const useTeam = ({
  dataTeam,
  dataRefreshTime,
  dataWidgetId,
  dataWidgetSport,
  dataWidgetCuid,
  dataEntityLinks,
  subscribers,
  sdkOptions,
}: IUseTeamArgs) => {
  const [isLoading, setIsLoading] = useState(false);
  const [team, setTeam] = useState<ITeam>();

  const fetchTeam = useCallback(
    (manageLoader: boolean) => {
      manageLoader && setIsLoading(true);
      if (dataTeam) {
        getTeamById({ team_id: dataTeam, sdkOptions })
          .then((response) => {
            manageLoader && setIsLoading(false);
            const team = normalizeTeamResponseData({ team: response, dataEntityLinks });
            setTeam(team);
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      }
    },
    [dataTeam, dataWidgetCuid, dataWidgetId, dataWidgetSport],
  );

  useFetchIntervalData(fetchTeam, dataRefreshTime);

  useEffect(() => {
    fetchTeam(true);
  }, [fetchTeam]);

  return {
    isLoading,
    team,
    handleClick: useSubscriptionClick({ dataWidgetId, dataWidgetSport, dataWidgetCuid, subscribers }),
  };
};
